import Cookies from 'js-cookie'
function AccessToken() {
    let accessToken = Cookies.get('access_token');
    return accessToken;
}

export default AccessToken;
